import client from '../client'

export const calculateDefaultPaymentKey = `${process.env.NEXT_PUBLIC_PURCHASE_DOMAIN}/api/Calculations/CalculateDefaultPayment`

export async function calculateDefaultPayment({ vehicleId, price }) {
  const params = new URLSearchParams({ vehicleId, price })

  return client(`${calculateDefaultPaymentKey}?${params}`)
}
